<template>
    <div class="w100 pl20 bg-w pr20 pt20 pb20" v-loading="loading">
        <div class="search-warp">
            <el-form :inline="true" label-width="80px"class="">
                <el-form-item label="建议类型" >
                    <el-select v-model="paramSearch.adviceType"
                               @change="getAdviceType"
                               placeholder="请选择建议类型" class="w100">
                        <el-option
                                v-for="item in typeList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门"
                 v-show="paramSearch.adviceType == 1">
                    <TreeSelect size="small"
                                :data="departmentData"
                                clearable
                                width="300px"
                                collapseTags
                                multiple
                                expandAll
                                ref="deptDouble"
                                :obj="mapKey"
                                checkStrictly
                                @getValue="setDeptDoubleMenu"></TreeSelect>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="table-con advice-main">
            <el-table class="w100 mt20 table" header-row-class-name="table-head"
                      row-class-name="cu-p" stripe :data="list" >
                <el-table-column align="center"  label="咨询建议">
                    <template slot-scope="scope">
                        <span v-text="scope.row.content" class="ellipsis"></span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="type" label="类型">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.type == 0">网站建议</span>
                        <span   v-if="scope.row.type == 1">部门建议</span>
                        <span  v-if="scope.row.type == 2">纠错</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="deptName" label="所涉部门"></el-table-column>
                <el-table-column align="center" prop="adviceTime" width="150px" label="建议时间">
                </el-table-column>
                <el-table-column align="center"   label="回复内容">
                    <template slot-scope="scope">
                        <span v-text="scope.row.answer" class="ellipsis"></span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="answerTime" width="150px" label="回复时间"></el-table-column>
                <el-table-column align="center" prop="answerTime" label="状态">
                    <template slot-scope="scope">
                        <el-tag type="success" size="small" v-if="scope.row.status == 1">已处理</el-tag>
                        <el-tag type="danger" size="small"  v-if="scope.row.status == 0">未处理</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="mt20 flex-box">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                           @current-change="changePage"
                           :current-page="paramSearch.current"
                           :page-sizes="pageSizes"
                           :page-size="paramSearch.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
    import TreeSelect from "@/components/TreeSelect.vue";
    import { getAdviceList,getAdviceTypeList} from '@/api/personalCenter/suggestAngMsg';
    import { getDeptTree} from '@/api/managementCenter/otherApi';

    export default {
        name: "Suggest",
        components: {
            TreeSelect
        },
        props: [],
        data() {
            return {
                loading: false,
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                    adviceType:'',
                    depts:[]
                },
                total: 0,
                typeList:[],
                departmentData:[],
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getListFn();
            this.getAdviceTypeListFn();
            this.getDeptTreeData();
        },
        methods: {
            getAdviceType(value){
                if(value == 1){
                    this.paramSearch.depts = []
                }
            },
            setDeptDoubleMenu(key,data){
                this.paramSearch.depts = data.map(item=>item.id)
            },
            // 获取部门数据
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        this.departmentData = data.data
                    }
                }).catch(err=>{

                })

            },

           // 获取建议类型
            getAdviceTypeListFn() {
                 getAdviceTypeList().then(({data})=> {
                if(data.code == 0){
                    const list = data.data || []
                    let arr = []
                    list.forEach(i=>{
                        for(let key in i){
                            arr.push({
                                name:i[key],
                                value:key
                            })
                        }
                    })
                    this.typeList =arr;
                }
             })
            },
            // 获取查询列表
            getListFn () {
                this.loading = true;
                getAdviceList(this.paramSearch).then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.list = data.data.records || []
                        this.total = data.data.total;
                    }
                })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            // 默认页面数据
            searchFn() {
                this.paramSearch.current=1
                this.getListFn();
            },

            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            mapToArr(arr,key){
                let list = arr || []
                return list.map(i=>i[key])
            }
        },
        watch: {},
        filters: {}
    };
</script>

<style scoped  lang="less">
    @import "../../../assets/css/handleBtn.less";
    .search-warp{
        height:40px ;
    }
    /deep/.el-table {
        width: 100%;
        .el-table__body-wrapper {
            max-height: calc(100vh - 300px);
            overflow-y: auto;

        }
    }

</style>
